import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Storage } from '@ionic/storage-angular';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class AuthenticateService {

 private readonly SESSIONS_KEY = 'SESSIONS_DATA';
  public url: string;
  public identity;
  public token;
    constructor(
        public http: HttpClient,
        private storage: Storage, private router: Router
    ){
        this.url=environment.url;
        // this.storage.create();  
         this.init();
        this.cargarSesionDesdeStorage();
     
    }

    async init() {
      // If using, define drivers here: await this.storage.defineDriver(/*...*/);
     await this.storage.create();
    }

    signup2(credenciales: any){
       console.log('el login',credenciales);
         const file2 = new FormData();
         file2.append('usuario', credenciales.usuario);
      //    console.log('el login',credenciales.usuario)
         file2.append('password', credenciales.password);
      //    console.log('el login',credenciales.password)
      const headers = new HttpHeaders();
      return new Promise(( res,rej) =>{
       this.http.post(this.url+'cliente/login',file2,{headers}).subscribe(
        async (respuesta: any) =>{
          this.identity=respuesta.user;
          console.log('login',respuesta);
          this.token = respuesta.tokencliete;
         //  console.log(this.token);
         //  console.log(this.identity);
          //Persistenvia de datoss
         //  localStorage.setItem('token',this.token);
         //  localStorage.setItem('identity',JSON.stringify( this.identity));
        //  await this.guardarTokenyidentity(this.token,respuesta.user);
         await this.guardarYActivarSesion(respuesta.user, this.token);
          res(true);

         },
        error =>{
          console.log(error);
          this.storage.clear();
          res(false);
        }
      );
      });
  }
    signup(user,gettoken = null){
      if(gettoken != null){
          user.gettoken = true;
      }
      const json = JSON.stringify(user);
      const params = 'json='+json;
      const headers = new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded');
      return new Promise(( res,rej) =>{
         this.http.post(this.url+'login',params,{headers }).subscribe(
          (response: any) =>{
            if(response.status !== 'error'){
                user.gettoken = true;
                const json2 = JSON.stringify(user);
                const params2 = 'json='+json2;
                this.token = response;
              this.http.post(this.url+'login',params2,{headers }).subscribe(
               async respuesta =>{

                this.identity=response;
                 console.log(respuesta);
                //  console.log(this.token);
                //  console.log(this.identity);
                 //Persistenvia de datos
                //  localStorage.setItem('token',this.token);
                //  localStorage.setItem('identity',JSON.stringify( this.identity));
                await this.guardarTokenyidentity(this.token,respuesta);
                 res(true);
                },
                error =>{
                  console.log( error);
                  this.storage.clear();
                  res(false);
                }
              );
              // form.reset();
            }else{
             console.log(response);
             this.storage.clear();
             res(false);
            }
          },
          error =>{
            console.log(error);
            this.storage.clear();
            res(false);
          }
        );


      });

  }

    async guardarYActivarSesion(identity: any, token: string) {
    // 1. Llama a tu función original para guardar la sesión activa.
    await this.guardarTokenyidentity(token, identity);

    // 2. Lógica ADICIONAL para manejar la lista de cuentas guardadas.
    let data = await this.storage.get(this.SESSIONS_KEY) || { saved_users: [] };
    const userIndex = data.saved_users.findIndex(u => u.id === identity.id);
    const nuevaSesionGuardada = { ...identity, token }; // Guardamos el token en la lista
//     const nuevaSesionGuardada = {
//   id: identity.id,
//   usuario: identity.usuario,
//   image: identity.image,
//   // Añade aquí cualquier otra propiedad simple que necesites guardar (ej. email)
//   token: token // El token de larga duración
// };
   console.log('nueva sesion guardada',nuevaSesionGuardada);
    if (userIndex > -1) {
      data.saved_users[userIndex] = nuevaSesionGuardada;
    } else {
      data.saved_users.push(nuevaSesionGuardada);
    }

    console.log('Datos de sesiones guardadas actualizados:', nuevaSesionGuardada);
    
    // 3. Guarda la lista actualizada.
    await this.storage.set(this.SESSIONS_KEY, data);
// localStorage.setItem(this.SESSIONS_KEY, JSON.stringify(data)); 
    // 4. Reconecta el socket (esto ya lo hace _guardarSesionActiva si lo pones ahí)
    // this.socketWebService.reconnectWithNewIdentity();
  }
  async guardarTokenyidentity(token: string,identity){
      this.token = token;
      this.identity = identity;
     await this.storage.set('token',token);
     await this.storage.set('identity',identity);
    // localStorage.setItem('token', token);
     localStorage.setItem('identity', JSON.stringify(identity)); 
       localStorage.setItem('identity', JSON.stringify(identity)); 
     
  }
  async recuperarToken(){
   return  await this.storage.get('token');
  }

  async recuperarIdentity(){
    return  await this.storage.get('identity');
   }
    private async cargarSesionDesdeStorage() {
    console.log('Intentando cargar sesión desde storage...');
    const tokenGuardado = await this.storage.get('token');
    const identidadGuardada = await this.storage.get('identity');

    if (tokenGuardado && identidadGuardada) {
      this.token = tokenGuardado;
      this.identity = identidadGuardada;
      console.log('Sesión cargada en el servicio.');
    } else {
      console.log('No se encontró sesión en storage.');
    }
  }
   logout(token):Observable<any>{
    const tokenToInvalidate = this.token; 
    
    // if (!tokenToInvalidate) {
      console.error("Intento de logout sin token. Limpiando localmente...");
      // this.realizarLimpiezaLocal();
      //  this.realizarLimpiezaLocalMultiSesion();
      // Retorna algo observable si es necesario para que no se rompa la suscripción
      return new Observable(observer => observer.complete());
    // }

    console.log('cerrado de sesion');
    console.log(token)
    //  let headers = new HttpHeaders() .set('Authorization','Bearer '+tokenToInvalidate);
    //  return this.http.post(this.url+'sesiones/actual',{}, { headers }).pipe(
    //   // 3. Después de que el servidor responde (exitosamente o con error), ejecuta la limpieza local
    //   tap(() => this.realizarLimpiezaLocalMultiSesion())
    // );
    //  return this.http.delete(this.url+'sesiones/actual',{headers});
 }

 cerrarSesion(token){
   console.log('cerrado de sesion',token);
 let headers = new HttpHeaders() .set('Authorization','Bearer '+token);
 return this.http.post(this.url+'sesiones/actual',{},{headers});
 }
public async realizarLimpiezaLocalMultiSesion() {
    console.log('Realizando limpieza local multi-sesión...');

    // 1. Resetea el socket a su estado inicial.
    // this.socketWebService.disconnectAndReset();

    // 2. Obtiene los datos de sesión para marcar al usuario como inactivo.
    const data = await this.storage.get(this.SESSIONS_KEY);
    if (data) {
      data.active_user_id = null;
      await this.storage.set(this.SESSIONS_KEY, data); // Guarda los datos actualizados
    }

    // NO borramos la lista completa, solo el estado activo en memoria.
    this.token = null;
    this.identity = null;
    this.eliminarDatos()

    // 4. Navega al login.
    this.router.navigateByUrl('/login');
  }
   private async realizarLimpiezaLocal() {
    // 4. Resetea el socket a su estado inicial
    

    // 5. Limpia todo el almacenamiento
    await this.storage.clear();
    localStorage.clear();

    // 6. Limpia las variables del servicio
    this.token = null;
    this.identity = null;
    
    // 7. Navega al login
    this.router.navigateByUrl('/login');
  }
   async logoutsotrage(){
      localStorage.removeItem('token');
    localStorage.removeItem('identity');
    await this.storage.remove('token');
    await this.storage.remove('identity');
  
    await this.storage.clear().then(()=>{
      this.router.navigateByUrl('/login');
    });
    this.token = null;
    this.identity = null;
   }
  async validarToken(){
    console.log('enviando ');
    const token = await this.storage.get('token');
    // console.warn('el token para vaidar',token);
    if (!token) {
      console.log('No hay token para validar. Limpiando datos locales...');
      await this.eliminarDatos();
      return false;
    }
    //  token = token !=  null ? token : ' ';

    const headers = new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded')
    .set('Authorization','Bearer '+token);
    if(token !=  null){
        return new Promise(( res,rej) =>{
           this.http.get(this.url+'validar',{headers}).subscribe((resp: any)=>{
            // console.log('toquen ',resp);
            if(resp.data.activacion === 1 ){
              res(true);
              }else{
                res(false);
                this.eliminarDatos();
              }
           },error=>{
            console.log(error);
            res(false);
            this.eliminarDatos();
          });
        });
    }else{
      return new Promise(( res,rej) =>{
          res(false);
          this.eliminarDatos();
      });
    }
  }
  getCliente(token,id): Observable<any>{

    const headers = new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded')
    .set('Authorization','Bearer '+token);
    return this.http.get(this.url+'cliente/'+id,{headers});
}
  updateLogoPrincipal(token,cliente,logo: FormData): Observable<any>{
    // let json = JSON.stringify(cliente);
    // let params = 'json='+json;
    console.log('service lof',cliente)
    logo.append('id', cliente.id);
    logo.append('image', cliente.image);
    logo.append('image2',cliente.image2);
    logo.append('image3',cliente.image3);
    logo.append('image4',cliente.image4);
    // const file = new FormData();
    // file.append('file',logo);
    // console.log(cliente);
    // logo.append('json',json);
    // console.log(logo);
    const headers = new HttpHeaders().set('Authorization','Bearer '+token);
    return this.http.post(this.url+'clienteupdatelogoprincipal/'+cliente.id,logo,{headers});
}
delateLogoPrincipal(token,cliente): Observable<any>{
  // let json = JSON.stringify(cliente);
  // let params = 'json='+json;

  //  const file = new FormData();
  // file.append('file',logo);
  // console.log(params);
  // file.append('json',json);
  // console.log(logo);
  const headers = new HttpHeaders().set('Authorization','Bearer '+token);
  return this.http.post(this.url+'clientedeletelogoprincipal/'+cliente.id,cliente,{headers});
}
updateCliente(token,cliente,logo,logo2,logo3,logo4): Observable<any>{

  const json = JSON.stringify(cliente);
  const file = new FormData();
  file.append('file',logo);
  file.append('file2',logo2);
  file.append('file3',logo3);
  file.append('file4',logo4);
  file.append('json',json);
  const headers = new HttpHeaders().set('Authorization','Bearer '+token);
  return this.http.post(this.url+'clienteupdate/'+cliente.id,file,{headers});
}
updateClientePosicion(token,cliente): Observable<any>{

  const headers = new HttpHeaders().set('Authorization','Bearer '+token);
  return this.http.post(this.url+'clienteupdateposicion/'+cliente.id,cliente,{headers});
}
registrarcancion(token,cliente): Observable<any>{


  // let json = JSON.stringify(cliente);
  // let params = 'json='+json;
  const json = JSON.stringify(cliente);
  const params = 'json='+json;
  // const file = new FormData();
  // file.append('file',logo);
  console.log('data registro historial',cliente);
  const file = new FormData();
  file.append('json',json);
  // logo.append('json',json);
  // console.log(logo);
  const headers = new HttpHeaders().set('Authorization','Bearer '+token);
  return this.http.post(this.url+'historialmovil',cliente,{headers});
}
getHistorialCliente(token,id): Observable<any>{

  const headers = new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded')
  .set('Authorization','Bearer '+token);
  return this.http.get(this.url+'historialmovil/'+id,{headers});
}

async eliminarDatos(){
  await this.storage.remove('token');
  await this.storage.remove('identity');
   // ✅ 2. LIMPIA TAMBIÉN LOCALSTORAGE
    // Esto es crucial para que al recargar la página después de un logout,
    // la app no crea que sigues conectado.
    localStorage.removeItem('token');
    localStorage.removeItem('identity');
  this.token = null;
  this.identity = null;
}
public getIdentityFromStorage(): any | null {
    const identityJson = localStorage.getItem('identity');
    if (identityJson) {
        return JSON.parse(identityJson);
    }
    return null;
}

  // ✅ 1. Método para obtener las cuentas guardadas
  async getSavedSessions(): Promise<any[]> {
    const data = await this.storage.get(this.SESSIONS_KEY);
    // return 
    // console.log('Datos de sesiones guardadas obtenidos:', data);
    //
    
    return   data ? data.saved_users :[];
  }

  // ✅ 3. Método para el login rápido (con una cuenta guardada)
  async loginConSesionGuardada(cuenta: any): Promise<boolean> {
    // Aquí deberías validar el token guardado con tu backend.
    // Si el token es válido, procede a guardar y activar la sesión.
    console.log(`Iniciando sesión rápida con ${cuenta.usuario}`);
    // this.guardarTokenyidentity(cuenta.token, cuenta);
    await this.guardarYActivarSesion(cuenta, cuenta.token);
    return true; // Asumiendo que la validación es exitosa
  }

  async eliminarCuentaGuardada(id: string) {
    console.log('Eliminando cuenta con ID desde auti:', id);
    let data = await this.storage.get(this.SESSIONS_KEY);
    if (data && data.saved_users) {
      data.saved_users = data.saved_users.filter(u => u.id !== id);
      await this.storage.set(this.SESSIONS_KEY, data);
    }
  }
  

  getSucursales(token,emmpresaid): Observable<any>{
  
    const headers = new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded')
    .set('Authorization','Bearer '+token);
    return this.http.get(this.url+'negocio/'+emmpresaid,{headers});
  }
  
  validacionNegocio(token,empresaid): Observable<any>{
    console.log('enviando ');
    const headers = new HttpHeaders().set('Content-Type','application/x-www-form-urlencoded')
    .set('Authorization','Bearer '+token);
    return this.http.get(this.url+'validarnegocio/'+empresaid,{headers});
}


}